import { Component, Input, OnInit } from '@angular/core';
import { ResponsiveService } from 'src/app/feature';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  showMore: boolean = false;
  constructor(private responsiveService: ResponsiveService) { }

  ngOnInit() { }

  get isMobile(): Observable<boolean> {
    return this.responsiveService.isMobileScreen$;
  }

}
